import { cn } from "../../helpers"
import { paragraph, title as TitleStyle } from "../typography"

const label = (className?: string) => cn(TitleStyle({ size: "xxs" }), "text-neutral-700", className)

export { label }
